<template>
	<div class="aermod-table-map">
		<div class="table-title">
			污染贡献分析: {{ station.name }} 
      <span style="font-size: 12px;">{{ station.name2 }}</span>
      <span style="font-size: 12px;">{{ station.name3 }}</span>
      
			<!-- <el-button 
				@click="closeTable"
				type="primary" 
				icon="el-icon-close" 
				circle 
				size="mini" 
				style="position: absolute;right: 5px;top: 5px">
			</el-button> -->
		</div>
		<div class="table-content">
			
			<el-table
		    :data="pollutionSourceData"
		    height="350"
		    border
		    size="small"
		    style="width: 100%">

		    <el-table-column
		      label="#"
		      type="index">
		    </el-table-column>

		    <el-table-column
		    	width="180"
		      label="污染源名称"
		      >
		      <template slot-scope="scope">
		        <span>{{ scope.row.name }}</span>
		      </template>
		    </el-table-column>
			
		    <el-table-column
		    	width="110"
		      label="贡献率(%)"
          sortable
		      :prop="data_type + '_rate'">
          <template slot-scope="scope">
		        <span>{{ scope.row[data_type + '_rate'] }}</span>
		      </template>
		    </el-table-column>

		    <el-table-column
		    	width="130"
		      label="敏感性分析排名"
          sortable
		      :prop="'s_' + data_type + '_rate_idx'">
          <template slot-scope="scope">
		        <span>{{ scope.row['s_' + data_type + '_rate_idx'] }}</span>
		      </template>
		    </el-table-column>

        <el-table-column
		    	width="110"
		      label="距离(米)"
          sortable
		      prop="dist">
		    </el-table-column>

			</el-table>
		</div>
		
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data () {
		return {

		}
	},
	computed: {},
	props:{
		station: Object,
		pollutionSourceData: Array,
    data_type: String
  },
  mounted() {
    console.log(this.tableData)
  },
	methods: {
		closeTable() {
			this.$emit("closeTable")
		},
		toPoint(info) {
			this.$emit("toPoint", info)
		},
	}
}
</script>

<style>

.aermod-table-map {
	position: absolute;
	top: 0;
  right: 0;
  margin-top: 140px;
	z-index: 100;
	width: auto;
	border: 1px solid black;
	background: white;
	border-radius: 10px
}

.table-title{
	color: white;
	font-size: 18px;
	height: 40px;
	line-height: 40px;
	background: #1891ff;
	padding-left: 20px;
	border-radius: 10px 10px 0 0 
}

.table-content{
	padding:10px 10px;

}

.table-export {
	margin-bottom: 5px;
	position: relative;
	height: 30px;
	line-height: 30px
}
</style>


// WEBPACK FOOTER //
// src/components/edf/aermodCard.vue